import React, { FC, MutableRefObject } from 'react';
import { makeStyles } from 'tss-react/mui';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import { transactionsTypes } from 'companion-app-components/flux/transactions';

import QIconButton from 'components/QIconButton';

import { RegListItem, styles } from '../styles';

import type { AttributesType, CallbacksType } from '../types';

const useStyles = makeStyles()(styles as Record<string, any>);

interface MenuFieldProps {
  attributes: AttributesType;
  callbacks: CallbacksType;
  SHOW_ALL: boolean;
  fieldActive: boolean;
  txn: transactionsTypes.CashFlowTransaction;
  showSplitsAndDetails: boolean;
  field: string;
  fieldIsEditable: (field: string) => void;
  focusField: MutableRefObject<HTMLAnchorElement | null>;
}

const MenuField: FC<MenuFieldProps> = ({
  attributes,
  callbacks,
  SHOW_ALL,
  fieldActive,
  txn,
  showSplitsAndDetails,
  field,
  fieldIsEditable,
  focusField,
}) => {
  const { classes } = useStyles();
  return (
    <RegListItem
      {...attributes}
      tabIndex={null}
      className={classes.iconButtonColumn}
      onClick={null}
    >
      {SHOW_ALL && fieldIsEditable(field) && ( 
        <QIconButton
          autoFocus={fieldActive}
          aria-label={!showSplitsAndDetails ? 'Show details' : 'Hide details'}
          ref={fieldActive ? (input) => {
            focusField.current = input; // eslint-disable-line
          } : null}
          focusRipple
          IconComponent={!showSplitsAndDetails ? ExpandMoreIcon : ExpandLessIcon}
          onClick={() => callbacks.handleMenu?.(showSplitsAndDetails ? 'hideDetails' : 'showDetails', txn)}
          size="small-target"
        />)}
    </RegListItem>
  );
};

export default MenuField;
